import React, { Component } from "react";
import { isUS } from "src/utils/account";
import { Deal } from "Types/api/Deal";
import { AccountState, VehicleState } from "Types/state";
import { reserveVehicle } from "./data";
import "./ReserveVehicle.scss";
import ReserveVehicleForm, { FormData } from "./ReserveVehicleForm";
import ReserveVehicleSuccess from "./ReserveVehicleSuccess";

export interface ReserveVehicleProps {
    account: AccountState;
    closeModal: () => void;
    person: any;
    uuid: string;
    vin: string;
    getDealPerson: (uuid: string) => void;
    patchDealPerson: (uuid: string, person: Deal["person"]) => void;
    region: string;
    vehicle: VehicleState;
    CTAText: string;
}

interface ReserveVehicleState {
    hasSubmitted: boolean;
    success: boolean;
}

class ReserveVehicle extends Component<ReserveVehicleProps, ReserveVehicleState> {
    constructor(props: ReserveVehicleProps) {
        super(props);

        this.state = {
            hasSubmitted: false,
            success: false,
        };
    }

    public render() {
        const { closeModal, person, account, vehicle, CTAText } = this.props;
        const { hasSubmitted, success } = this.state;

        return (
            <div className="ReserveVehicle">
                {!hasSubmitted || (hasSubmitted && !success) ? (
                    <ReserveVehicleForm
                        account={account}
                        hasError={hasSubmitted && !success}
                        onSubmit={this.submitForm}
                        onSuccess={this.onSuccess}
                        region={this.props.region}
                        dealId={this.props.uuid}
                        values={person}
                        vehicle={vehicle}
                        CTAText={CTAText}
                    />
                ) : (
                    <ReserveVehicleSuccess account={account} closeModal={closeModal} title={CTAText} />
                )}
            </div>
        );
    }

    private submitForm = async (data: FormData): Promise<boolean> => {
        const { uuid, vin, getDealPerson, patchDealPerson, region } = this.props;
        try {
            await reserveVehicle(uuid, vin, data);

            const preferences = {
                preferences: isUS(region)
                    ? { tcpa_consent: true }
                    : {
                          opt_in_marketing: data.optInMarketing,
                          opt_in_transactional: data.optInTransactional,
                      },
            };

            patchDealPerson(uuid, preferences);

            getDealPerson(uuid);
        } catch (err) {
            this.setState({ hasSubmitted: true, success: false });
            return false;
        }
        return true;
    };

    private onSuccess = () => {
        this.setState({ hasSubmitted: true, success: true });
    };
}

export default ReserveVehicle;
